import { Link } from "react-router-dom";
import { kuaibaoList } from "@/mocks/kuaibao";
import type { KuaibaoItem } from "@/types/kuaibao";
import { formatHeat } from "@/utils/format";

const sorted = [...(kuaibaoList as KuaibaoItem[])].sort((a, b) => b.heat - a.heat);

export default function TrendBoard() {
  const top = sorted[0];
  const rest = sorted.slice(1, 8);

  return (
    <section id="bang" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-6 h-[3px] rounded-full bg-primary-500"></span>
              <span className="font-label text-xs tracking-[0.2em] text-primary-600">
                HOT LIST
              </span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              今日瓜单榜
            </h2>
            <p className="font-label text-sm text-foreground-500 mt-2">
              按全网讨论热度实时排序，先看前十名就够跟上节奏
            </p>
          </div>
          <Link
            to="/kuaibao?sort=heat"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 font-label text-sm transition-colors whitespace-nowrap"
          >
            完整榜单
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-5 flex flex-col bg-background-100 border border-background-200/80 rounded-lg overflow-hidden">
            <Link
              to={`/kuaibao/${top.slug}`}
              className="relative block w-full h-56 md:h-64 overflow-hidden"
            >
              <img
                src={top.cover}
                alt={`${top.title} 配图`}
                title={`${top.title} - 51.cg今日吃瓜单`}
                className="w-full h-56 md:h-64 object-top object-cover"
              />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-accent-500 text-accent-950 font-label text-xs font-semibold">
                <i className="ri-trophy-line leading-none"></i>
                榜首
              </span>
            </Link>
            <div className="p-5 md:p-6 flex flex-col flex-1">
              <Link
                to={`/kuaibao?cat=${top.categorySlug}`}
                className="self-start inline-flex px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 font-label text-xs mb-3"
              >
                {top.category}
              </Link>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug mb-3">
                <Link
                  to={`/kuaibao/${top.slug}`}
                  className="hover:text-primary-600 transition-colors"
                >
                  {top.title}
                </Link>
              </h3>
              <p className="font-label text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                {top.summary}
              </p>
              <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between font-label text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 text-primary-600 font-medium">
                  <i className="ri-fire-line leading-none"></i>
                  热度 {formatHeat(top.heat)}
                </span>
                <Link
                  to={`/kuaibao/${top.slug}`}
                  className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors"
                >
                  读全文
                  <i className="ri-arrow-right-line leading-none"></i>
                </Link>
              </div>
            </div>
          </article>

          <div className="lg:col-span-7 bg-background-100 border border-background-200/80 rounded-lg p-2 md:p-3">
            <ol className="flex flex-col">
              {rest.map((item, i) => (
                <li key={item.slug}>
                  <Link
                    to={`/kuaibao/${item.slug}`}
                    className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-md hover:bg-background-50 transition-colors group"
                  >
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                        i < 2
                          ? "bg-primary-500 text-background-50"
                          : "bg-accent-100 text-accent-900"
                      }`}
                    >
                      {String(i + 2).padStart(2, "0")}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block font-heading font-semibold text-foreground-950 text-sm md:text-base leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </span>
                      <span className="font-label text-xs text-foreground-500 line-clamp-1 mt-0.5">
                        {item.summary}
                      </span>
                    </span>
                    <span className="hidden sm:inline-flex items-center gap-1 font-label text-xs text-foreground-500 shrink-0">
                      <i className="ri-fire-line text-primary-500 leading-none"></i>
                      {formatHeat(item.heat)}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>

        <div className="mt-6 sm:hidden">
          <Link
            to="/kuaibao?sort=heat"
            className="inline-flex w-full items-center justify-center gap-1.5 px-4 py-2.5 rounded-md border border-background-300 text-foreground-700 font-label text-sm"
          >
            查看完整榜单
            <i className="ri-arrow-right-line leading-none"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}